module.exports = __webpack_public_path__ + "static/media/7.23c8b1f3.jpg";